// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//   React context
import {useMaterialUIController} from "context";
import {Grid, Typography} from "@mui/material";
import dayjs from "dayjs";
import {formatDate} from "constants/ApplicationConstants";
import properties from "constants/ApplicationConstants";
function Bill_Experience({experiences, noGutter}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox pt={1} pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="medium" fontFamily={properties.fontFamily}>
          Experience
        </Typography>
      </MDBox>
      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={darkMode ? "transparent" : "grey-100"}
        borderRadius="lg"
        p={1}
        mb={noGutter ? 0 : 1}
        mt={1}
      >
        <MDBox width="100%" display="flex" flexDirection="column">
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={2}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Position &nbsp;
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={2}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Company Name &nbsp;
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={2}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Join Date &nbsp;
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={2}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Leave Date &nbsp;
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={2}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Location &nbsp;
                </Typography>
              </MDBox>
            </Grid>
          </Grid>
          {experiences
            ? experiences.map((experiences, index) => (
                <Grid container spacing={2} mb={2}>
                  <Grid item xs={12} sm={2}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {experiences.positionName ? experiences.positionName : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        textTransform="capitalize"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {experiences.companyName ? experiences.companyName : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {experiences.joinDate ? formatDate(experiences.joinDate) : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {experiences.leaveDate ? formatDate(experiences.leaveDate) : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {experiences.location ? experiences.location : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>
                </Grid>
              ))
            : []}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of Bill
Bill_Experience.defaultProps = {
  noGutter: false
};

// Typechecking props for the Bill
Bill_Experience.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool
};

export default Bill_Experience;
